import React, { useEffect } from 'react';
import { Input, Checkbox } from 'semantic-ui-react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import ReactPaginate from 'react-paginate';
import debounce from '../../../utils/debounce';
import './pagination-style.css';
import FindFolders from './FindFolders';
import ModalCreateFolder from '../../TemplateGenerator/FoldersModals/ModalCreateFolder';
import ModalAllFolders from '../../TemplateGenerator/FoldersModals/ModalAllFolders';
import { closeRecommendedTemplate } from '../../../actions/folders';
import FilterBlock from '../../Templates/TemplatesList/FilterBlock';

const FindTemplateContainer = ({
  handleCheckTemplate,
  pageCount,
  isLoadTemplates,
  errMessTemplates,
  template,
  getFolders,
  searchNameTemplate,
  setTemplatePaginationPage,
  setSearchTemplateName,
  choosedTemplateTags,
  isShowRecommendedTemplate,
  isRecommended,
  user,
  selectedComplex,
  toggleRecommendedTemplateCheckbox,
  onAllFolderModal,
  onCreateFolderModal,
  closeRecommendedTemplate,
  tags,
  filterBlockWidth,
  searchFieldWidth,
  tabSelected,
}) => {
  const handlePageClick = (pageNumber) => {
    setTemplatePaginationPage(pageNumber.selected + 1);
    if (user.id && isShowRecommendedTemplate && selectedComplex) {
      getFolders(pageNumber.selected + 1, searchNameTemplate, '', user.id, selectedComplex.period);
    } else {
      getFolders(pageNumber.selected + 1, searchNameTemplate);
    }
  };

  useEffect(() => {
    if (user.id && isShowRecommendedTemplate && selectedComplex) {
      getFolders('', searchNameTemplate, '', user.id, selectedComplex.period);
    } else {
      getFolders('', searchNameTemplate);
    }
  }, [onAllFolderModal, onCreateFolderModal]);

  const handleChangeSearchTemplates = debounce((text) => {
    if (text.length > 2 || text === '') {
      setSearchTemplateName(text);
      closeRecommendedTemplate();
      if (user.id && isShowRecommendedTemplate && selectedComplex) {
        getFolders(null, text, choosedTemplateTags, user.id, selectedComplex.period);
      } else {
        getFolders(null, text, choosedTemplateTags);
      }
    }
  }, 700);

  return (
    <TemplatesContainer>
      <div
        style={{ width: '100%', justifyContent: 'center', alignItems: 'center', display: 'flex' }}
      >
        <Input
          style={{ width: searchFieldWidth }}
          onChange={(e) => handleChangeSearchTemplates(e.target.value)}
          placeholder="Поиск по шаблонам/папкам..."
        />
        {isRecommended && (
          <Checkbox
            style={{ marginLeft: '10px' }}
            label="Показывать рекомендованные"
            onChange={toggleRecommendedTemplateCheckbox}
            checked={isShowRecommendedTemplate}
          />
        )}
      </div>
      <FilterBlock filterBlockWidth={filterBlockWidth} getTemplates={getFolders} tags={tags} />
      <FindFolders
        handleCheckTemplate={handleCheckTemplate}
        tabSelected={tabSelected}
        isLoad={isLoadTemplates}
        errMess={errMessTemplates}
        selectedTemplateId={template ? template.complex_menu_id : 0}
        pageCount={pageCount}
        searchFieldWidth={searchFieldWidth}
      />
      <ReactPaginate
        previousLabel="<"
        nextLabel=">"
        breakLabel="..."
        pageCount={pageCount}
        marginPagesDisplayed={3}
        pageRangeDisplayed={3}
        onPageChange={handlePageClick}
        previousLinkClassName="prev-page-btn"
        nextLinkClassName="next-page-btn"
        containerClassName="pagination"
        activeLinkClassName="active-page-btn"
        pageLinkClassName="page-btn"
        breakClassName="break-me"
        background="white"
      />
      <ModalCreateFolder />
      <ModalAllFolders />
    </TemplatesContainer>
  );
};

const mapStateToProps = (state) => {
  const { user } = state.reducers;
  const { isShowRecommendedTemplate } = state.folders;
  const { selectedComplex } = state.complex;
  const {
    onAllFolderModal,
    templateFolders,
    onCreateFolderModal,
    choosedTemplateTags,
  } = state.folders;
  return {
    isShowRecommendedTemplate,
    user,
    selectedComplex,
    onAllFolderModal,
    templateFolders,
    onCreateFolderModal,
    choosedTemplateTags,
  };
};

const mapDispatchToProps = (dispatch) => ({
  closeRecommendedTemplate: () => dispatch(closeRecommendedTemplate()),
});

export default connect(mapStateToProps, mapDispatchToProps)(FindTemplateContainer);

const TemplatesContainer = styled.div`
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (max-width: 992px) {
    width: 80%;
  }
`;



// WEBPACK FOOTER //
// ./src/Components/Common/FindTemplateContainer/FindTemplateContainer.jsx